<template>
  <div class="tab-container">
    <div class="tab-header">
      <div class="d-flex flex-column">
        <span class="ap-title ap-title__main">{{ $t('userConfiguration.dialog') }}</span>
        <span class="ap-subtitle ap-subtitle__main">{{ $t('userConfiguration.dialogSub') }}</span>
      </div>
    </div>
    <div class="tab-body">
      <div
        v-for="module in modules"
        :key="module.moduleCode"
        class="row printer-row bottom-bordered mx-0 px-0"
      >
        <div
          class="type col-9 secondary-color d-flex align-items-center pl-0"
        >
          {{ module.label }}
        </div>
        <div class="col-3 pr-0">
          <vt-loading-button
            size="sm"
            block
            class="btn__outline"
            :params="{ promise: () => resetModalState(module.uiComponentModalState, module.storeModalState, module.moduleCode) }"
          >
            {{ $t('userConfiguration.resetBtn') }}
          </vt-loading-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import customConfigResource from '@/api/resources/ui/CustomConfigResource'
import { store } from '@/store/store'
import { ModuleOperation } from '@/api/operations/models/module-operation'

export default {
    name: 'ModalsUserConf',
    components: {
    },
    data() {
        return {
            isHide: true,
            placement: 'bottom',
            labelsFormatMayHaveChangedUiComponentName: 'uicomponent.registry.labelsFormatMayHaveChanged.modalconfig'
        }
    },
    computed: {
        modules() {
            const printDialog = [{
                label: this.$i18n.tc('global.printing'),
                uiComponentModalState: 'uicomponent.print.modalconfig',
                storeModalState: 'printModalsState'
            }]
            return this.$store.getters.modules.filter(module => module.showDialogBox).concat(printDialog)
        }
    },
    methods: {
        showPasswordModal() {
            this.$refs.passwordModal.show()
        },
        async resetModalState(uiComponentModalState, storeModalState, moduleCode) {
            if (uiComponentModalState && storeModalState) {
                await customConfigResource.save(uiComponentModalState, {})
                const modalsState = store.getters.modalsState
                modalsState[storeModalState] = null
                this.$store.commit('updateModalsState', modalsState)
                if (moduleCode === ModuleOperation.REGISTRY) {
                    await customConfigResource.save(this.labelsFormatMayHaveChangedUiComponentName, {})
                }
                this.showToastSuccessGlobal(this.$t('global.modal.userConfiguration.resetModalSuccess'))
            }
        }
    }
}

</script>

<style>
    .modals-state-user-conf {
        height: calc(67vh - 50px);
        overflow-y: auto;
    }
</style>
